import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-bar-main" }

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import BreadcrumbChevronTopBar from '@/design-system/molecules/BreadcrumbChevronTopBar.vue'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import ContainerLogo from '@/design-system/atoms/ContainerLogo.vue'
import MenuUserSettingsCard from '@/design-system/molecules/MenuUserSettingsCard.vue'
import { useStore } from 'vuex'
import { useGeneralStore } from '@/pinia'
import InputSearch from '@/design-system/molecules/InputSearch.vue'
import LayoutSearch from '@/design-system/organisms/LayoutSearch.vue'
import { setViewToMapview } from '@/utils/views'
import { useI18n } from 'vue-i18n'
import { getRealmId } from '@/utils/realmId'
import { zoomToEntities } from '@/composables/useMapbox'
import { useSelectionStore } from '@/pinia/selectionNew'
// emits
interface EMITS {
  (e: 'openDoodle')
  (e: 'toggleSearchOverlay') // Unused???
  (e: 'toggleSearchInput', active: boolean) // Unused???
}

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutTopBar',
  emits: ["openDoodle", "toggleSearchOverlay", "toggleSearchInput"],
  setup(__props, { emit: __emit }) {

const emits = __emit

// reactive variables etc
const { t } = useI18n()
const piniaStore = useGeneralStore()
const clearInput = ref(false)
const hoverTextLogo = ref(
  `${t('general__text__show')} ${t('general__text__portfolio-entire').toLowerCase()} ${t(
    'general__text__in'
  ).toLowerCase()} ${t('general__view__mapview').toLowerCase()}`
)
const isTyping = ref(false)
const realmId = getRealmId()
const searchString = ref('')
const showMenu = ref(false)
const showSearchInput = ref(false)
const store = useStore()

// computed
const allComplexes = computed(() => store.getters.allComplexes)
const isIndoorviewShowing = computed(() => store.getters.isIndoorviewShowing)
const mobileScreen = computed<boolean>(() => store.state.mobileScreen)
const { showOverlayModalPinia } = storeToRefs(piniaStore)
const selection = useSelectionStore()

async function reset() {
  if (showOverlayModalPinia.value) piniaStore.setShowOverlayModalPinia(false)
  await store.dispatch('RESET_ALL_SELECTIONS')
  store.commit('SET_CLICKED_ITEM_TYPE', { type: 'region' })
  setViewToMapview()
  selection.clear()
  zoomToEntities(allComplexes.value.map((complex) => complex.id))
}

function searchStringValue(searchValue: string) {
  if (searchValue.length >= 1) {
    isTyping.value = true
    clearInput.value = false
  } else {
    isTyping.value = false
  }
  searchString.value = searchValue
}

function toggleMenu() {
  showMenu.value = !showMenu.value
}

function toggleSearchInput(active: boolean) {
  // If the tickets overlay modal is open while search is activated, the user could end up with a half empty-modal after selecting a new object.
  // Perhaps the piniaStore.setShowOverlayModalPinia(false) function below should be moved to category selection and search selection instead,
  // but we currently have category and search bugs which need to be fixed first. Placing the function here is a temporary fix to prevent errors.
  if (showOverlayModalPinia.value) piniaStore.setShowOverlayModalPinia(false) // Move when bugs have been fixed?
  showSearchInput.value = active
  clearInput.value = !active
  if (!active) searchStringValue('')
  emits('toggleSearchOverlay')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!mobileScreen.value || (mobileScreen.value && !showSearchInput.value))
        ? (_openBlock(), _createBlock(ContainerLogo, {
            key: 0,
            class: _normalizeClass(["top-bar-main__logo", {
        'top-bar-main__logo__no-search-or-breadcrumb': mobileScreen.value
      }]),
            hoverText: hoverTextLogo.value,
            "logo-src": require('@/design-system/assets/images/Logo-Digital-Buildings-Black.svg'),
            role: "button",
            tabindex: "0",
            onClick: reset,
            onKeydown: [
              _withKeys(reset, ["enter"]),
              _withKeys(reset, ["space"])
            ]
          }, null, 8, ["class", "hoverText", "logo-src"]))
        : _createCommentVNode("", true),
      (!mobileScreen.value)
        ? (_openBlock(), _createBlock(BreadcrumbChevronTopBar, {
            key: 1,
            class: "top-bar-main__breadcrumbs"
          }))
        : _createCommentVNode("", true),
      (!isIndoorviewShowing.value)
        ? (_openBlock(), _createBlock(InputSearch, {
            key: 2,
            class: "top-bar-main__search",
            "show-search-input": showSearchInput.value,
            "mobile-screen": mobileScreen.value,
            placeholderText: 
        isIndoorviewShowing.value
          ? _unref(t)('general__text__search-placeholder-IV')
          : _unref(realmId) === 'akademiskahus'
          ? _unref(t)('general__text__search-placeholder-AH')
          : _unref(t)('general__text__search-placeholder')
      ,
            clearInput: clearInput.value,
            onToggleSearchInput: toggleSearchInput,
            onEmitSearchString: searchStringValue
          }, null, 8, ["show-search-input", "mobile-screen", "placeholderText", "clearInput"]))
        : _createCommentVNode("", true),
      ((!mobileScreen.value || (mobileScreen.value && !showSearchInput.value)) && !isIndoorviewShowing.value)
        ? (_openBlock(), _createBlock(ButtonPrimary, {
            key: 3,
            class: "search-button",
            iconLeft: 
        showSearchInput.value
          ? require('@/design-system/assets/icons/Icon-X.svg')
          : require('@/design-system/assets/icons/Icon-Search-WH.svg')
      ,
            size: "medium-icon",
            onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (showSearchInput.value ? toggleSearchInput(false) : toggleSearchInput(true)))
          }, null, 8, ["iconLeft"]))
        : _createCommentVNode("", true),
      (!mobileScreen.value)
        ? (_openBlock(), _createBlock(ButtonPrimary, {
            key: 4,
            class: "doodle-button",
            iconLeft: require('@/design-system/assets/icons/Icon-Brush-01-White.svg'),
            size: "medium-icon",
            onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (emits('openDoodle')))
          }, null, 8, ["iconLeft"]))
        : _createCommentVNode("", true),
      (!mobileScreen.value || (mobileScreen.value && !showSearchInput.value))
        ? (_openBlock(), _createBlock(ButtonOutline, {
            key: 5,
            class: "user-settings",
            iconLeft: require('@/design-system/assets/icons/Icon-User.svg'),
            size: "medium-icon",
            onOnClicked: toggleMenu
          }, null, 8, ["iconLeft"]))
        : _createCommentVNode("", true),
      (showSearchInput.value)
        ? (_openBlock(), _createBlock(LayoutSearch, {
            key: 6,
            class: "top-bar-main__search-menu",
            isTyping: isTyping.value,
            searchString: searchString.value,
            mobileScreen: mobileScreen.value,
            onCloseSearchOverlay: _cache[2] || (_cache[2] = () => toggleSearchInput(false)),
            onClearSearch: _cache[3] || (_cache[3] = () => (clearInput.value = true))
          }, null, 8, ["isTyping", "searchString", "mobileScreen"]))
        : _createCommentVNode("", true)
    ]),
    (showMenu.value)
      ? (_openBlock(), _createBlock(MenuUserSettingsCard, {
          key: 0,
          onCloseMenu: toggleMenu
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})